<template>
  <div>
    <div class="from-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control campos">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de resolución</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los tipos de resoluciones</option>        
        <option v-for="(tipoResolucion,index) in tiposResoluciones" :value="tipoResolucion.TipoResolucionId" :key="index">{{tipoResolucion.Nombre}}</option>
      </select>      
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        tiposResoluciones: [],
        idDelModelo:null
      }
    },
    props: {            
      parametros:Object,
      valorDefinido:Number,
      idDelInput:String,      
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      }
    },
    computed:{
      
    },
    methods: {
      /**
       * Metodo para asignar la llave del elmento seleccionado del catalogo 003TiposResoluciones
       * @param {object} evento [evento emitido por el select]
       */
      cambiarDatos(evento){
        this.idDelModelo = evento.target.value;
        const valoresDelCatalogo =
        {
          llave: this.idDelInput,
          valor: evento.target.value 
        }

        this.$store.dispatch("A_SICSEN_Catalogos_003TiposResoluciones",valoresDelCatalogo);
        this.$emit("valorParaElPadre",evento);
        // para obtener label del select => let labelTipoPagina = evento.target.options[evento.target.selectedIndex].text;
      },
      /**
       * Metodo para lenar catalogo 003TiposResoluciones mediante el llamado de la API
       */
      cargarTiposResoluciones: function() {
        // definimos metodo de API
        const SERVIDOR = api.conexion;
        const METODO_API_AGREGAR = api.SICSEN.catalogos.C003TiposResoluciones;
        let urlApi = SERVIDOR + METODO_API_AGREGAR;
        // creamos la peticion con el formulario
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {};
        
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba;
        let peticionMetodoGetTiposResolucionesAPI = this.parametros;
        // contruir header de la peticion
        let peticionArchivos = false;
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);
        comun.SeEstaCargandoInformacion(true);
        axios.post(urlApi, peticionMetodoGetTiposResolucionesAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } else {
                        /* utilizar solo en etapa de desarrollo 
                        console.log("ejecuto bien paginas controller:: ",respuesta.data); */
                        this.tiposResoluciones = respuesta.data.TiposResoluciones;
                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                }
        ) // axios.post
      }
    }, 
    mounted(){
      // establecer valor default
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

        const valoresDelCatalogo = {
          llave: this.idDelInput,
          valor: this.idDelModelo
        }
      this.$store.dispatch("A_SICSEN_Catalogos_003TiposResoluciones", valoresDelCatalogo);
    },
    created() {
      this.cargarTiposResoluciones();
    }
  }
</script>
<style scoped>
 .campos{
  background-color: white;
  color: black;
  }
</style>


// WEBPACK FOOTER //
// src/components/SICSEN/Catalogos/C003TiposResoluciones.vue